import styled from "styled-components";

import PageWrapper from "Components/Pages/Wrapper";

export const PageContainer = styled(PageWrapper)`
  padding-top: 20px;
  padding-bottom: 20px;
  box-sizing: border-box;
`;

export const PageContent = styled.div`
  display: flex;
  flex-direction: column;

  .page-heading {
    flex-wrap: nowrap;
  }

  & > .separator {
    width: 100%;
    border-bottom: 1px solid #cccccc;
    margin: 30px 0;
  }

  .budget-detailed,
  .page-heading {
    padding: 0 40px;
  }
`;

export const MainContent = styled.div`
  width: 100%;
  padding: 10px 20px;
  box-sizing: border-box;

  .section-title {
    margin-top: 100px;
  }

  .result-error {
    font-size: 16px;
    text-align: center;
    color: gray;
    margin-top: 40px;
  }
`;

export const Container = styled.div`
  width: 100%;

  .text-md {
    font-size: 1.3rem;
  }

  .message-success {
    max-width: 450px;
    margin: 0 auto;
    text-align: center;
  }

  .schedule-sec {
    margin-top: 60px;
  }

  .scheduleinfo {
    font-size: 1rem;
  }
`;

export const ContainerForm = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 400px;
  margin: 0 auto;
  margin-top: 20px;
`;

export const ContainerResult = styled.table`
  margin: 0 auto;
  margin-top: 50px;
  width: 70%;

  table {
    thead tr td {
      color: var(--color-purple);
      font-size: 16px;
      font-weight: 600;
      padding: 0 15px;
    }

    tbody tr td {
      font-size: 16px;
      color: var(--color-gray-text);
    }
  }
`;
